<div class="view-attachment-container">
  <div class="attachment-header-content" [class.bg-blur]="isDescriptionExpanded">
    <div class="details-page-header-wrapper">
      <div class="attachment-name">
        <rkt-icon name="document"></rkt-icon>
        <div>{{ name }}</div>
      </div>

      <div class="action-buttons">
        @if (canUpdate) {
          @if (!readOnly) {
            <button class="action-button trash-button" [disabled]="false | accessControl | async" (click)="activeModal.close('DELETE')">
              <rkt-icon name="trash"></rkt-icon>
            </button>
          }
          @if (!readOnly) {
            <button class="action-button" [disabled]="false | accessControl | async" (click)="activeModal.close('EDIT')">
              <rkt-icon name="edit"></rkt-icon>
            </button>
          }
          <button class="action-button" (click)="onDownloadClick()"><rkt-icon name="download"></rkt-icon></button>
        }
        <button class="action-button" (click)="activeModal.close()"><rkt-icon name="times"></rkt-icon></button>
      </div>
    </div>
    @if (description) {
      <div class="attachment-description">
        <div [class.collapse]="!isDescriptionExpanded">{{ description }}</div>
        <button class="expand-collapse-button" (click)="onExpandCollapse()">
          <rkt-icon [name]="isDescriptionExpanded ? 'chevron-up' : 'chevron-down'"></rkt-icon>
        </button>
      </div>
    }
  </div>

  <div class="attachment-preview">
    @if (url && fileFormat === 'PDF') {
      <ngx-extended-pdf-viewer
        [src]="url"
        [showBorders]="false"
        [showToolbar]="false"
        [textLayer]="false"
        [sidebarVisible]="false"
        backgroundColor="#F7F7F7"
        [authorization]="true"
      >
      </ngx-extended-pdf-viewer>
    } @else {
      @if (url && isImageFormat) {
        <div class="image-preview">
          <img [src]="url" [alt]="name" />
        </div>
      } @else {
        <div class="empty-container">
          <div class="empty-container-icon">
            <div class="empty-list-placeholder"></div>
          </div>
          <div class="empty-container-description">
            <div>No preview available</div>
            <div>Try downloading the file to view it</div>
          </div>
          <button rktButton class="download-button" (click)="onDownloadClick()"><rkt-icon name="download"></rkt-icon>Download</button>
        </div>
      }
    }
  </div>
</div>
